import { Action } from "@ngrx/store";
import { AnswerPayload } from "src/app/shared/interfaces/answer-payload";
import { CourseGroupExerciseRequest } from "src/app/shared/interfaces/course-group-exercise-request";
import { GradeTextAnswer } from "src/app/shared/interfaces/grade-text-answer";
import { GradeTextAnswerRequest } from "src/app/shared/interfaces/grade-text-answer-request";
import { GradeTextCommentRequest } from "src/app/shared/interfaces/grade-text-comment-request";
import { ManualGradeTextAnswerRequest } from "src/app/shared/interfaces/manual-grade-text-answer-request";
import { StudentShortTextAnswer } from "src/app/shared/interfaces/student-short-text-answer";
import { Guid } from "src/app/shared/types/guid";

export const ANSWER_TEXT = "[ExerciseShortText Method] AnswerText";
export const ANSWER_TEXT_SUCCESS =
  "[ExerciseShortText Method] AnswerText Success";
export const ANSWER_TEXT_FAILURE =
  "[ExerciseShortText Method] AnswerText Failure";

export const LIST_STUDENT_ANSWERS =
  "[ExerciseShortText Method] ListStudentAnswers";
export const LIST_STUDENT_ANSWERS_SUCCESS =
  "[ExerciseShortText Method] ListStudentAnswers Success";
export const LIST_STUDENT_ANSWERS_FAILURE =
  "[ExerciseShortText Method] ListStudentAnswers Failure";

export const LIST_TEACHER_GRADE_ANSWERS =
  "[ExerciseShortText Method] ListTeacherGradeAnswers";
export const LIST_TEACHER_GRADE_ANSWERS_SUCCESS =
  "[ExerciseShortText Method] ListTeacherGradeAnswers Success";
export const LIST_TEACHER_GRADE_ANSWERS_FAILURE =
  "[ExerciseShortText Method] ListTeacherGradeAnswers Failure";

export const GRADE_STUDENT_ANSWER =
  "[ExerciseShortText Method] GradeStudentAnswer";
export const GRADE_STUDENT_ANSWER_SUCCESS =
  "[ExerciseShortText Method] GradeStudentAnswer Success";
export const GRADE_STUDENT_ANSWER_FAILURE =
  "[ExerciseShortText Method] GradeStudentAnswer Failure";

export const COMMENT_STUDENT_ANSWER =
  "[ExerciseShortText Method] CommentStudentAnswer";
export const COMMENT_STUDENT_ANSWER_SUCCESS =
  "[ExerciseShortText Method] CommentStudentAnswer Success";
export const COMMENT_STUDENT_ANSWER_FAILURE =
  "[ExerciseShortText Method] CommentStudentAnswer Failure";

export const GRADE_STUDENT_ANSWER_MANUAL =
  "[ExerciseShortText Method] GradeStudentAnswerManual";
export const GRADE_STUDENT_ANSWER_MANUAL_FAILURE =
  "[ExerciseShortText Method] GradeStudentAnswerManual Failure";

export class GradeStudentAnswerManual implements Action {
  readonly type = GRADE_STUDENT_ANSWER_MANUAL;
  constructor(public payload: ManualGradeTextAnswerRequest) {}
}

export class GradeStudentAnswerManualFailure implements Action {
  readonly type = GRADE_STUDENT_ANSWER_MANUAL_FAILURE;
}

export class CommentStudentAnswer implements Action {
  readonly type = COMMENT_STUDENT_ANSWER;

  constructor(public payload: GradeTextCommentRequest) {}
}

export class CommentStudentAnswerSuccess implements Action {
  readonly type = COMMENT_STUDENT_ANSWER_SUCCESS;

  constructor(
    public payload: { gradeTextAnswer: GradeTextAnswer; exerciseId: Guid },
  ) {}
}

export class CommentStudentAnswerFailure implements Action {
  readonly type = COMMENT_STUDENT_ANSWER_FAILURE;
}

export class GradeStudentAnswer implements Action {
  readonly type = GRADE_STUDENT_ANSWER;
  constructor(public payload: GradeTextAnswerRequest) {}
}

export class GradeStudentAnswerSuccess implements Action {
  readonly type = GRADE_STUDENT_ANSWER_SUCCESS;
  constructor(
    public payload: { gradeTextAnswer: GradeTextAnswer; exerciseId: Guid },
  ) {}
}

export class GradeStudentAnswerFailure implements Action {
  readonly type = GRADE_STUDENT_ANSWER_FAILURE;
}

export class ListTeacherGradeAnswers implements Action {
  readonly type = LIST_TEACHER_GRADE_ANSWERS;

  constructor(public payload: CourseGroupExerciseRequest) {}
}

export class ListTeacherGradeAnswersSuccess implements Action {
  readonly type = LIST_TEACHER_GRADE_ANSWERS_SUCCESS;

  constructor(
    public payload: { gradeAnswers: GradeTextAnswer[]; exerciseId: Guid },
  ) {}
}

export class ListTeacherGradeAnswersFailure implements Action {
  readonly type = LIST_TEACHER_GRADE_ANSWERS_FAILURE;
}

export class ListStudentAnswers implements Action {
  readonly type = LIST_STUDENT_ANSWERS;

  constructor(public payload: CourseGroupExerciseRequest) {}
}

export class ListStudentAnswersSuccess implements Action {
  readonly type = LIST_STUDENT_ANSWERS_SUCCESS;

  constructor(
    public payload: { answers: StudentShortTextAnswer[]; exerciseId: Guid },
  ) {}
}

export class ListStudentAnswersFailure implements Action {
  readonly type = LIST_STUDENT_ANSWERS_FAILURE;
}

export class AnswerText implements Action {
  readonly type = ANSWER_TEXT;

  constructor(public payload: AnswerPayload) {}
}

export class AnswerTextSuccess implements Action {
  readonly type = ANSWER_TEXT_SUCCESS;

  constructor(
    public payload: {
      studentShortTextAnswer: StudentShortTextAnswer;
      exerciseId: Guid;
    },
  ) {}
}

export class AnswerTextFailure implements Action {
  readonly type = ANSWER_TEXT_FAILURE;

  constructor(public payload: { exercise: { id: Guid } }) {}
}

export type ExerciseShortTextActions =
  | AnswerText
  | AnswerTextSuccess
  | AnswerTextFailure
  | ListStudentAnswers
  | ListStudentAnswersSuccess
  | ListStudentAnswersFailure
  | ListTeacherGradeAnswers
  | ListTeacherGradeAnswersSuccess
  | ListTeacherGradeAnswersFailure
  | GradeStudentAnswer
  | GradeStudentAnswerSuccess
  | GradeStudentAnswerFailure
  | GradeStudentAnswerManual
  | GradeStudentAnswerManualFailure
  | CommentStudentAnswer
  | CommentStudentAnswerSuccess
  | CommentStudentAnswerFailure;
